<template>
  <div
    class="project-strucutre-taktarea-element"
    >
    <v-icon>list_alt</v-icon>
    <div class="ml-1">{{name}}</div>
  </div>
</template>
<script>
  export default {
    props: ['name'],
    data: () => ({
    }),
  }
</script>
<style>
  .project-strucutre-taktarea-element {
    display: flex;
    flex-shrink: 0;
    white-space: nowrap;
  }
</style>
